export default __webpack_public_path__ + "static/media/assessment-page-background.d0abcb91.svg";